import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const CHARSET_MEDIA_TYPES = /^(application\/json|text\/[\w.+-]+)\s*$/i;

@Injectable()
export class ContentTypeCharsetInterceptor implements HttpInterceptor {
  intercept( req: HttpRequest<unknown>, next: HttpHandler ): Observable<HttpEvent<unknown>> {
    const contentType = req.headers.get( 'Content-Type' ) ?? req.detectContentTypeHeader();

    if ( !contentType || !CHARSET_MEDIA_TYPES.test( contentType ) ) {
      return next.handle( req );
    }

    return next.handle( req.clone( {
      setHeaders: { 'Content-Type': `${ contentType.trim() }; charset=utf-8` }
    } ) );
  }
}
